module.exports = "<p>תוכלו לשנות את פרטי החשבון שלכם באמצעות לחיצה על לחצן ה”חשבון&quot; בעמוד הבית.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/3.md
// module id = 816
// module chunks = 0